import React, { useEffect } from "react";
import { Image } from "react-bootstrap";
import logo from "../icon-192x192.png";
import "../styles.css";
import ContainerBody from "../components/ContainerBody";
import ButtonLink from "../components/ButtonLink";
import ContainerNav from "../components/ContainerNav";
import Typography from "@mui/material/Typography";
import ContainerRoot from "../components/ContainerRoot";
import { useTranslation } from "react-i18next";
import Language from "../components/Language";

export default function WelcomePage(props) {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(props.language);
  }, [i18n, props.language]);

  return (
    <ContainerRoot>
      <ContainerBody>
        <Typography>{t("Welcome")}</Typography>
        <Image className="logo" src={logo} roundedCircle />
      </ContainerBody>
      <ContainerNav>
        <Language language={props.language} setLanguage={props.setLanguage} />
        <ButtonLink
          url="/image"
          title={t("Choose the image")}
          color="primary"
        />
      </ContainerNav>
    </ContainerRoot>
  );
}
